import { ILaya } from "../../ILaya";
import { Event } from "../events/Event";
import { RelationType } from "./Const";
import { PopupManager } from "./PopupManager";
import { UIConfig2 } from "./UIConfig";
import { GWidget } from "./GWidget";
import { GWindow } from "./GWindow";
import { Loader } from "../net/Loader";
import { HideFlags } from "../Const";
export class GRoot extends GWidget {
    static get inst() {
        var _a;
        return (_a = GWidget._defaultRoot) !== null && _a !== void 0 ? _a : (GWidget._defaultRoot = new GRoot());
    }
    constructor() {
        super();
        this.name = "GRoot";
        this.zOrder = GRoot.LAYER;
        this.mouseThrough = true;
        this.hideFlags |= HideFlags.HideAndDontSave;
        this.size(ILaya.stage.width, ILaya.stage.height);
        ILaya.stage.addChild(this);
        this._popupMgr = new PopupManager(this);
        this._modalLayer = new GWidget();
        this._modalLayer.mouseEnabled = true;
        this._modalLayer.hideFlags |= HideFlags.HideAndDontSave;
        this._modalLayer.size(this.width, this.height);
        this._modalLayer.addRelation(this, RelationType.Size);
        ILaya.stage.on(Event.RESIZE, () => {
            this.size(ILaya.stage.width, ILaya.stage.height);
        });
    }
    get popupMgr() {
        return this._popupMgr;
    }
    showWindow(win) {
        this.addChild(win);
        if (win.x > this.width)
            win.x = this.width - win.width;
        else if (win.x + win.width < 0)
            win.x = 0;
        if (win.y > this.height)
            win.y = this.height - win.height;
        else if (win.y + win.height < 0)
            win.y = 0;
        this.adjustModalLayer();
    }
    hideWindow(win) {
        win.hide();
    }
    hideWindowImmediately(win) {
        if (win.parent == this)
            this.removeChild(win);
        this.adjustModalLayer();
    }
    bringToFront(win) {
        let cnt = this.numChildren;
        let i;
        if (this._modalLayer.parent && !win.modal)
            i = this.getChildIndex(this._modalLayer) - 1;
        else
            i = cnt - 1;
        for (; i >= 0; i--) {
            let g = this.getChildAt(i);
            if (g == win)
                return;
            if (g instanceof GWindow)
                break;
        }
        if (i >= 0)
            this.setChildIndex(win, i);
    }
    showModalWait(msg) {
        if (UIConfig2.globalModalWaiting) {
            if (this._modalWaitPane == null)
                this._modalWaitPane = Loader.createNodes(UIConfig2.globalModalWaiting);
            this._modalWaitPane.size(this.width, this.height);
            this._modalWaitPane.addRelation(this, RelationType.Size);
            this.addChild(this._modalWaitPane);
            this._modalWaitPane.text = msg || "";
        }
    }
    closeModalWait() {
        if (this._modalWaitPane && this._modalWaitPane.parent)
            this.removeChild(this._modalWaitPane);
    }
    closeAllExceptModals() {
        let arr = this.children.slice();
        let cnt = arr.length;
        for (let i = 0; i < cnt; i++) {
            let g = arr[i];
            if ((g instanceof GWindow) && !g.modal)
                g.hide();
        }
    }
    closeAllWindows() {
        let arr = this.children.slice();
        let cnt = arr.length;
        for (let i = 0; i < cnt; i++) {
            let g = arr[i];
            if (g instanceof GWindow)
                g.hide();
        }
    }
    getTopWindow() {
        let cnt = this.numChildren;
        for (let i = cnt - 1; i >= 0; i--) {
            let g = this.getChildAt(i);
            if (g instanceof GWindow) {
                return g;
            }
        }
        return null;
    }
    get modalLayer() {
        return this._modalLayer;
    }
    get hasModalWindow() {
        return this._modalLayer.parent != null;
    }
    get modalWaiting() {
        return this._modalWaitPane && this._modalWaitPane.displayedInStage;
    }
    showPopup(popup, target, dir) {
        this._popupMgr.showPopup(popup, target, dir);
    }
    togglePopup(popup, target, dir) {
        return this._popupMgr.togglePopup(popup, target, dir);
    }
    hidePopup(popup) {
        this._popupMgr.hidePopup(popup);
    }
    get hasAnyPopup() {
        return this._popupMgr.hasAnyPopup;
    }
    adjustModalLayer() {
        let cnt = this.numChildren;
        if (this._modalWaitPane && this._modalWaitPane.parent)
            this.setChildIndex(this._modalWaitPane, cnt - 1);
        for (let i = cnt - 1; i >= 0; i--) {
            let g = this.getChildAt(i);
            if ((g instanceof GWindow) && g.modal) {
                if (this._modalLayer.graphics.cmds.length === 0)
                    this._modalLayer.graphics.drawRect(0, 0, 1, 1, UIConfig2.modalLayerColor, null, 0, true);
                if (this._modalLayer.parent == null)
                    this.addChildAt(this._modalLayer, i);
                else
                    this.setChildIndexBefore(this._modalLayer, i);
                return;
            }
        }
        if (this._modalLayer.parent)
            this.removeChild(this._modalLayer);
    }
}
GRoot.LAYER = 1000;
